/**
 * Human-readable game titles keyed by URL slug (used by SubNavbar, SEO, etc.)
 *
 * The data lives in src/seo/gameNames.js because the build-time SEO and sitemap scripts require it
 * from Node, which cannot import an ES module. This re-export keeps every existing importer working.
 */
import gameNames from '../seo/gameNames';

export const gameNameMap = gameNames.gameNameMap;
